import { Component, forwardRef, ChangeDetectorRef } from '@angular/core';
import {
	NG_VALUE_ACCESSOR,
	ControlValueAccessor,
	FormBuilder,
	FormGroup,
} from '@angular/forms';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { UserListArgs } from 'src/shared/api';
import { FormConfig } from 'src/shared/form-models/form-cva.component';
import { takeUntil } from 'rxjs/operators';
import { CustomerUserListFilters } from '../customer-users.utility';

const customerUserListFiltersFormConfig: FormConfig<CustomerUserListFilters> = {
	searchText: [''],
	customerId: [''],
};

@Component({
	selector: 'rpfsa-customer-user-list-filters',
	templateUrl: './customer-user-list-filters.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CustomerUserListFiltersComponent),
			multi: true,
		},
	],
})
export class CustomerUserListFiltersComponent extends SelfDestruct
	implements ControlValueAccessor {
	form = this.fb.group(customerUserListFiltersFormConfig) as FormGroup;

	constructor(
		private readonly fb: FormBuilder,
		private readonly cd: ChangeDetectorRef
	) {
		super();
	}

	// model --> view
	writeValue(value: UserListArgs): void {
		if (value) {
			this.form.reset(value, { emitEvent: false });
			this.cd.detectChanges();
		}
	}

	// view --> model
	registerOnChange(fn: (value: CustomerUserListFilters) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = fn;
	}

	onTouched: () => void = () => {};
}
